var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-box",class:{'is-open':_vm.isOpen}},[_c('div',{staticClass:"toggle-headline",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.headline))]),_c('div',{staticClass:"toggle-content",style:(_vm.getHeight)},[_c('div',{ref:"content",staticClass:"rte",class:{'is-2col':_vm.columns},domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }